﻿const accordions = document.getElementsByClassName("accordion");

Array.from(accordions).forEach(accordion => {
    const accordionItems = accordion.getElementsByClassName("accordion-item");

    Array.from(accordionItems).forEach(accordionItem => {
        var button = accordionItem.getElementsByClassName("accordion-button")[0];

        button.addEventListener("touchstart", handleAccordionButton);
        button.addEventListener("click", handleAccordionButton);
    });
});

function handleAccordionButton(evt) {
    evt.preventDefault();
    const isNotOpen = this.classList.contains("collapsed");
    const accordionCollapse = document.getElementById(this.dataset.bsTarget);
    const accordion = document.getElementById(accordionCollapse.dataset.bsParent);
    const buttons = accordion.getElementsByClassName("accordion-button");
    const accordionCollapses = accordion.getElementsByClassName("accordion-collapse");
    Array.from(buttons).forEach(button => {
        button.classList.add("collapsed");
        button.setAttribute("aria-expanded", "false");
    });
    Array.from(accordionCollapses).forEach(ac => {
        ac.classList.remove("show");
    });
    if (isNotOpen) {
        this.classList.remove("collapsed");
        this.setAttribute("aria-expanded", "true");
        accordionCollapse.classList.add("show");
    } else {
        this.classList.add("collapsed");
        this.setAttribute("aria-expanded", "false");
        accordionCollapse.classList.remove("show");
    }
}